/**
 * @generated SignedSource<<181a9f163c700d7f3974c7328592b2e6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersIsVelocityWallArticle$data = {
  readonly paywallTypes: ReadonlyArray<{
    readonly entityId: string;
  } | null> | null;
  readonly " $fragmentType": "helpersIsVelocityWallArticle";
};
export type helpersIsVelocityWallArticle$key = {
  readonly " $data"?: helpersIsVelocityWallArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersIsVelocityWallArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersIsVelocityWallArticle"
};

(node as any).hash = "5bf52b16f389a82e4b98aa30c1c43405";

export default node;
